export default __webpack_public_path__ + "static/media/sushi1.72e01c73.svg";